import React, { useState, useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// @mui
import { Alert, Stack } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'; // Import the utc plugin
dayjs.extend(utc); // Extend dayjs with the utc plugin
import api from 'src/api';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { toast } from 'react-toastify';
import moment from 'moment';

export default function WinHistoryByGameAndDate({ selectedGame }) {
  const [session, setSession] = useState('');
  const [gameId, setGameID] = useState(selectedGame?.master_game_id || '');
  const [filterDate, setFilterDate] = useState();
  const dispatch = useDispatch();

  const [masterGameData, setMasterGameData] = useState([]);
  const [gameTypes, setGameTypes] = useState([]);

  const getAllMasterGames = async () => {
    const response = await api.get('/master-games');
    setMasterGameData(response.data.results);
  };

  const getAllValues = async () => {
  
    const isoFormattedDate = filterDate.toISOString();
    const apiUrl = `/winners/game-and-date?date=${isoFormattedDate}&game_id=${gameId}`;

    dispatch(loadingStartAction());
    const response = await api.get(apiUrl);

    dispatch(loadingStopAction());

    setGameTypes(response.data);
  };

  useEffect(() => {
    getAllMasterGames();
  }, []);

  return (
    <>
      <Stack spacing={3} my={2} direction="row">
        <FormControl
          sx={{
            width: 200,
          }}
        >
          <InputLabel id="demo-simple-select-label">Select Game</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={gameId}
            label="Select Game"
            onChange={(e) => setGameID(e.target.value)}
          >
            {masterGameData?.map((item) => {
              return (
                <MenuItem key={item._id} value={item._id}>
                  {item.game_name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
            <DatePicker
              label="Select Date"
              value={filterDate}
              onChange={(newValue) => {
                setFilterDate(newValue);
              }}
            />
          </DemoContainer>
        </LocalizationProvider>
        <LoadingButton size="large" type="submit" variant="contained" onClick={getAllValues}>
          Show Info
        </LoadingButton>
      </Stack>

      {gameTypes?.map((item) => {
        return (
          <Alert sx={{ mx: 1, my: 1 }} severity={item?.totalBids ? 'success' : 'error'}>
            {item.game_type_name} - {item?.totalBids ? item.totalBids : 0}
          </Alert>
        );
      })}
    </>
  );
}
